"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = Flag;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const link_generation_1 = require("../../utils/link-generation");
const Flag_module_scss_1 = __importDefault(require("./Flag.module.scss"));
function Flag({ isOn, flagKey, name, tags, defaultOffValue, initialValue, currentValue, valueOptions, setFlagValue, otherInfo, jiraUrl, launchDarklyUrl, jiraTicket, description, isFeatureFlag, overrides }) {
    let value = defaultOffValue;
    if (overrides[flagKey] !== undefined) {
        value = overrides[flagKey];
    }
    else if (currentValue != null) { // catches both undefined and null, allows for false, 0, and other falsey values
        value = currentValue;
    }
    /* use current (starting) value if `value` hasn't been defined to allow for generation of the default state link as well */
    const saatvaLink = getSaatvaLink(flagKey, value || currentValue);
    const onDropDownChange = (event) => {
        event && event.preventDefault();
        setFlagValue(flagKey, event.target.value);
    };
    /* normalize value from string 'boolean' after returned from select value */
    if (value === 'true') {
        value = true;
    }
    else if (value === 'false') {
        value = false;
    }
    const currentlyOverridden = value !== initialValue;
    const flagClassNames = (0, classnames_1.default)(Flag_module_scss_1.default.flag, {
        [Flag_module_scss_1.default['flag--isOn']]: isOn,
        [Flag_module_scss_1.default.overriddenFlag]: currentlyOverridden
    });
    const ldStatusLink = (0, classnames_1.default)(Flag_module_scss_1.default.ldLink, {
        [Flag_module_scss_1.default['ldLink--isFeature']]: isFeatureFlag
    });
    return ((0, jsx_runtime_1.jsxs)("li", { className: flagClassNames, children: [(0, jsx_runtime_1.jsx)("a", { href: saatvaLink, title: description, className: Flag_module_scss_1.default.name, children: name || flagKey }), (0, jsx_runtime_1.jsxs)("div", { className: Flag_module_scss_1.default.main, children: [(0, jsx_runtime_1.jsxs)("div", { className: Flag_module_scss_1.default.links, children: [(0, jsx_runtime_1.jsx)("a", { target: "_blank", href: launchDarklyUrl, className: (0, classnames_1.default)(Flag_module_scss_1.default.info, Flag_module_scss_1.default.infoLink, ldStatusLink), style: { color: 'white' }, children: "LD" }), jiraTicket && jiraUrl && (0, jsx_runtime_1.jsx)("a", { target: "_blank", href: jiraUrl, className: (0, classnames_1.default)(Flag_module_scss_1.default.info, Flag_module_scss_1.default.infoLink, Flag_module_scss_1.default.jiraLink), style: { color: 'white' }, children: jiraTicket }), otherInfo && otherInfo.map((info, i) => {
                                return (0, jsx_runtime_1.jsx)("span", { className: Flag_module_scss_1.default.info, children: info }, i);
                            }), tags.length > 0 && tags.map((tag, i) => {
                                return (0, jsx_runtime_1.jsx)("span", { className: `${Flag_module_scss_1.default.info} ${Flag_module_scss_1.default['info--tag']}`, children: tag }, `tag-${i}`);
                            })] }), (0, jsx_runtime_1.jsx)("div", { className: Flag_module_scss_1.default.selectContainer, children: (0, jsx_runtime_1.jsx)("select", { "aria-label": 'Flag value selector', onChange: onDropDownChange, className: Flag_module_scss_1.default.select, value: value, children: valueOptions.map((option) => {
                                return (0, jsx_runtime_1.jsx)("option", { value: option, children: getValueLabel(option) }, option);
                            }) }) })] })] }));
}
const getSaatvaLink = (flagKey, currentValue) => {
    const queryString = (0, link_generation_1.getOverrideQueryString)({ [flagKey]: currentValue });
    return (0, link_generation_1.addQueryString)('ldOverrides', queryString);
};
const getValueLabel = (value) => {
    if (value === true) {
        return 'true';
    }
    if (value === false) {
        return 'false';
    }
    return value;
};
Flag.propTypes = {
    /** the flag key */
    flagKey: prop_types_1.default.string.isRequired,
    /** the flag name */
    name: prop_types_1.default.string,
    /** the default value when targeting is "off" */
    defaultOffValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
    /** the current flag value */
    currentValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
    /** the initial flag value a user was assigned (before overrides) */
    initialValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool]).isRequired,
    /** the possible values for the flag */
    valueOptions: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired,
    /** a function to set the new override for a flag */
    setFlagValue: prop_types_1.default.func.isRequired,
    /** an array of other info to be displayed for the flag */
    otherInfo: prop_types_1.default.arrayOf(prop_types_1.default.string),
    /** the url for the ticket in jira  */
    jiraUrl: prop_types_1.default.string,
    /** a url for the feature flag in the launch darkly dashboard */
    launchDarklyUrl: prop_types_1.default.string.isRequired,
    /** jira ticket attached to feature flag key */
    jiraTicket: prop_types_1.default.string,
    /** description of feature flag set in launch darkly */
    description: prop_types_1.default.string,
    /** boolean that tells if this flag is a feature flag */
    isFeatureFlag: prop_types_1.default.bool,
    /** boolean that tells if this flag has been overridden */
    isOverridden: prop_types_1.default.bool,
    /** overrides that have been selected in the widget  */
    overrides: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string, prop_types_1.default.bool])).isRequired
};
//# sourceMappingURL=Flag.js.map